import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

import useHostingNavigate from '~/hooks/useHostingNavigate';
import DomainFormWithCTB from '~/scenes/AddSetupSiteFlows/components/DomainFormWithCTB';
import BtnGroup from '~/scenes/AddSetupSiteFlows/components/MultiStepCard/BtnGroup';

import { defaultFormData, FormDataType } from '../..';

export type ConnectDomainWithCTBPropOptions = {
  formData: FormDataType;
  setFormData?: Function;
  changeLoading?: boolean;
  isLoadingDomainAvailability?: boolean;
};

const ConnectDomainWithCTB = ({
  formData,
  setFormData = () => {},
  changeLoading = false,
  isLoadingDomainAvailability = false,
}: ConnectDomainWithCTBPropOptions) => {
  const hostingNavigate = useHostingNavigate();
  const [error, setError] = useState(false);
  const { reset, watch, setValue } = useFormContext();
  const value = watch('domain', formData?.domain);

  // preventPath will change when a path is entered/removed by the user (see DomainForm logic)
  // It applies to basic hosting and generic site cases
  const [preventPath, setPreventPath] = useState(false);

  const handleCancel = () => {
    reset(defaultFormData);
    hostingNavigate();
  };

  const disableCTA = () =>
    changeLoading ||
    preventPath ||
    (value === '' && !formData.autoGeneration) ||
    (error && value !== '');

  return (
    <DomainFormWithCTB
      formData={formData}
      //@ts-expect-error
      setFormData={setFormData}
      preventPath={preventPath}
      setPreventPath={setPreventPath}
      error={error}
      setError={setError}
      value={value}
      setValue={(domain) => setValue('domain', domain)}
      disabled={isLoadingDomainAvailability}
    >
      <BtnGroup
        hasSkipBtn={false}
        hasCancelBtn
        onCancelHandler={handleCancel}
        onCloseHandler={handleCancel}
        disabled={disableCTA()}
        loading={changeLoading}
        domainChangeLoading={isLoadingDomainAvailability}
        type={formData.subtype}
        btnType="submit"
      />
    </DomainFormWithCTB>
  );
};

export default ConnectDomainWithCTB;
